var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav flex"},[_c('p',[_vm._v("当前位置：")]),_c('span',{on:{"click":function($event){return _vm.indexHandle()}}},[_vm._v("首页")]),_vm._l((_vm.navList),function(item,index){return _c('span',{key:index,on:{"click":function($event){return _vm.navHandle(item)}}},[_c('i',[_vm._v(">")]),_vm._v(_vm._s(item.strName))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }